import * as React from 'react';
import { StoreConsumer } from '../index';
import { setHOCAndWrappedComponentName } from '../../../../utils/reactHelpers';

export const connectStore = (Component) => {
  return function ConnectStore(props) {
    setHOCAndWrappedComponentName(ConnectStore, Component);
    return (
      <StoreConsumer>
        {({ store, setStore }) => {
          return <Component store={store} setStore={setStore} {...props} />;
        }}
      </StoreConsumer>
    );
  };
};
